import { render, staticRenderFns } from "./lookChatDetails.vue?vue&type=template&id=c42a8c56&scoped=true"
import script from "./lookChatDetails.vue?vue&type=script&lang=js"
export * from "./lookChatDetails.vue?vue&type=script&lang=js"
import style0 from "./lookChatDetails.vue?vue&type=style&index=0&id=c42a8c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42a8c56",
  null
  
)

export default component.exports